<ul style="margin-top: 0" sd-list-inline [alignement]="positionEnum.top" class="is-m">
  @for (card of linkCards; track card) {
    <li class="col-24 col-m-12 col-l-8">
      <sd-link-card [linkCard]="card" [titleLevel]="titleLevel" [isFit]="isFit" [brand]="brandCorner" />
    </li>
  }
</ul>
